<template>
  <div class="button-box">
    <slot></slot>
    <div class="page-transition"></div>
  </div>
</template>

<script>
export default {
  name: 'scissorsButton',
}
</script>

<style lang="scss" scoped>
.button {
  padding: 11px 24px;
  position: relative;
  display: table;
  border-radius: 50px;
  margin: 0 auto;
  margin-top: layout-val-8(7);
  cursor: pointer;
  color: $black;

  p{
    padding-bottom: 0 !important;
  }

  &::before {
    content: "";
    position: absolute;
    width: 48px;
    height: 48px;
    top: 0;
    left: 0;
    background: url('https://teamchangingacademy.nl/wp-content/uploads/2019/04/schaar-1.png') no-repeat center center / contain;
     transition: .6s all;
  }
  
  &::after {
    width: 100%;
    content: "";
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;
    border: 1px dashed $black;
    border-radius: 50px;
    @include transition-cubic-out-back; 
  }
  
  &:hover::after {
    width: 48px;
    height: 48px;
    @include transition-cubic-out-back-combi-back;
  }
  p{
    font-weight: 900;
    opacity: 1;
  }
}
</style>